module.exports = __webpack_public_path__ + "fonts/Lufthansa Head Bold.0b0089e5.otf";